<style lang="scss" scoped>
.dom-move {
  display: flex;

  position: absolute;
  top: 0;
  left: 0;
  z-index: 111;

  width: 100%;
  height: 100%;

  flex-direction: column;
  .ctn {
    position: relative;

    width: 100%;

    flex: 1;
  }
  .slot {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
  }
  .mask {
    display: block;

    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.6);
    background-size: cover;

    content: '';
  }
}
</style>

<template>
  <transition name="fade">
    <div
      v-show="show"
      v-dom-move="{ target: target }"
      class="dom-move"
      :style="{
        overflow: showMask ? 'hidden' : '',
        zIndex: showMask ? zIndex : '110'
      }"
      @click="clickMask"
    >
      <div
        class="ctn"
        :style="{
          marginTop: `${top}px`
        }"
      >
        <!-- 有蒙板 不能滑动 -->
        <div v-if="showMask && preventMove" class="mask" @touchmove.prevent>
          <slot></slot>
        </div>
        <!-- 有蒙板 能滚动 -->
        <div v-if="showMask && !preventMove" class="mask">
          <slot></slot>
        </div>
        <div v-if="!showMask" class="slot">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * 蒙版组件，将dom提取到body，需要独自处理dom添加移除逻辑
 */
// eslint-disable-next-line no-unused-vars
import { isMallApp } from '@mc/mc-base-env/src/web/platform'
export default {
  name: 'McMask',
  props: {
    top: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: false
    },
    showMask: {
      type: Boolean,
      default: true
    },
    target: {
      type: String,
      default: ''
    },
    zIndex: {
      type: String,
      default: ''
    },
    preventMove: {
      type: Boolean,
      default: true
    },
    backgroundImage: {
      type: String,
      default: 'none'
    }
  },
  watch: {
    show(nval) {
      // 如果有具体容器，需要检验容器是否已经移出dom，app的v-show会将dom删除
      // eslint-disable-next-line camelcase
      if (nval && this.target && isMallApp) {
        const container = document.querySelector(this.target)
        // eslint-disable-next-line eqeqeq
        if (container && this.$el.parentElement != container) {
          container.appendChild(this.$el)
        }
      }
    }
  },
  // 针对keep-alive组件
  // 进入页面重新添加到body
  activated() {
    if (!this.$el.parentNode) {
      document.body.appendChild(this.$el)
    }
  },
  // 离开页面缓存el到内存
  deactivated() {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  methods: {
    clickMask() {
      this.$emit('clickMask')
    }
  }
}
</script>
